var React = require('react');

function Microphone (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M80 256V96a96 96 0 0 1 192 0v160a96 96 0 0 1-192 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M352 256c0 88.9-66.29 162.47-152 174.23V464h56a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h56v-34.15C64 417.71 0 337.8 0 248.16V208a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16v42.3c0 66.81 48.71 126.59 115.21 133.08A128.15 128.15 0 0 0 304 256v-48a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

Microphone.defaultProps = {"viewBox":"0 0 352 512","className":"icon"};

module.exports = Microphone;

Microphone.default = Microphone;
